export const isSuccessfulUploadStatus = (status: number): boolean =>
  status >= 200 && status < 300;
